module.exports = __webpack_public_path__ + "img/xk.003130b8.svg";